import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { brandConfig } from '../config/brands';
import { manualProductTabLabel } from '../config/brands/productLabels';
import { useMaterialsPanelStore } from '../stores/materialsPanelStore';
import { usePublicActors } from '../features/exclusive-actors/hooks';
import type { ExclusiveActor } from '../features/exclusive-actors/types';
import { HomeHeroMenu } from '../components/home/HomeHeroMenu';
import MaterialsFloatingOpenButton from '../components/panels/MaterialsFloatingOpenButton';
import './HomePage.css';

const SUPABASE_URL = 'https://lirsarznxaidebqhgxch.supabase.co';

function getFaceImageUrl(actor: ExclusiveActor): string | null {
  if (actor.face_image_bucket && actor.face_image_path) {
    return `${SUPABASE_URL}/storage/v1/object/public/${actor.face_image_bucket}/${actor.face_image_path}`;
  }
  return null;
}

export default function HomePage() {
  const navigate = useNavigate();
  const { close } = useMaterialsPanelStore();
  const { data: publicData } = usePublicActors();

  useEffect(() => {
    close();
  }, [close]);

  const actorsWithFace = (publicData?.actors ?? []).filter((a) => getFaceImageUrl(a));
  const displayActors = actorsWithFace.slice(0, 8);

  return (
    <div className="home-page">
      <div className="home-container">

        {/* ─── Hero ─── */}
        <HomeHeroMenu />

        {/* ─── Secondary ─── */}
        <section className="home-secondary">
          <div className="home-sub-card">
            <img src="/database_2.svg" alt="" className="home-sub-icon" />
            <div className="home-sub-body">
              <h3 className="home-sub-title">{brandConfig.labels.products}登録・管理</h3>
              <div className="home-sub-links">
                {brandConfig.features.amazonIntegration && (
                  <>
                    <button className="home-sub-link" onClick={() => navigate('/products/amazon')}>
                      <span className="home-sub-link-name">Amazon連携</span>
                      <span className="home-sub-link-desc">Amazonセラーの方</span>
                    </button>
                    <span className="home-sub-divider" />
                  </>
                )}
                <button className="home-sub-link" onClick={() => navigate('/products/manual')}>
                  <span className="home-sub-link-name">{manualProductTabLabel(brandConfig)}</span>
                  <span className="home-sub-link-desc">その他ECサイト・無形商材の方</span>
                </button>
              </div>
            </div>
          </div>

          <div className="home-sub-card home-sub-card--actors">
            <img src="/composition_window_man.svg" alt="" className="home-sub-icon" />
            <div className="home-sub-body">
              <div className="home-sub-title-row">
                <h3 className="home-sub-title">{brandConfig.labels.aiActors}</h3>
                <Link to="/exclusive-actors" className="home-actors-catalog-link">
                  {brandConfig.labels.aiActor}カタログを見る
                </Link>
              </div>
              {displayActors.length > 0 && (
                <div className="home-actors-row">
                  <span className="home-actors-label">人気の{brandConfig.labels.aiActor}</span>
                  <div className="home-actors-faces">
                    {displayActors.map((actor) => {
                      const url = getFaceImageUrl(actor);
                      return (
                        <div key={actor.id} className="home-actor-face" title={actor.display_name}>
                          {url && <img src={url} alt={actor.display_name} />}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

      </div>
      <MaterialsFloatingOpenButton />
    </div>
  );
}
